const STORAGE_KEY = "demand-signal-session"

/**
 * 리뷰 중복 제출 판정용 브라우저 식별자(B2C-472).
 *
 * 연락처가 없는 리뷰는 이 값으로 연타만 막는다. 서버는 이 키가 비면
 * 매번 새 값으로 취급하므로, 저장소를 못 쓰는 환경에서도 제출은 성공한다.
 */
export const getSessionKey = (): string | undefined => {
  if (typeof window === "undefined") return undefined
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY)
    if (stored) return stored
    const created = crypto.randomUUID()
    window.localStorage.setItem(STORAGE_KEY, created)
    return created
  } catch {
    // 사파리 프라이빗 모드 등 저장소 접근이 막힌 환경. 중복 판정만 포기하고 제출은 살린다.
    return undefined
  }
}
